'use client'

/* eslint-disable @typescript-eslint/no-explicit-any */
import useSWR, { SWRConfiguration, SWRResponse } from 'swr'
import type { FetcherResponse } from 'swr/_internal'

import useHttpRequest from '@hooks/useHttpRequest'

export default function useCustomSWR<T>(
  key: any,
  fetcher?: ((arg: any) => FetcherResponse<T>) | undefined,
  config?: SWRConfiguration,
): SWRResponse<T> {
  const locale = 'us'
  const { clientFetch } = useHttpRequest()

  const internalFetcher =
    typeof fetcher !== 'undefined'
      ? fetcher
      : (resource: RequestInfo, init: RequestInit): unknown => clientFetch(`/api/${locale}${resource}`, init, 'json')

  return useSWR(key, internalFetcher, { revalidateOnFocus: false, ...config }) as SWRResponse<T>
}
